import React, { useMemo } from 'react';
import { NetworkIndicator } from '@components/Song/MintComponents/NetworkIndicator';
import { formatUSD, formatWeiToEthForDisplay } from '@utils/helpers';

export const PriceBreakdown = ({
  chainId,
  totalCost,
}: {
  chainId: number;
  totalCost: { wei: bigint; usd: number };
}) => {
  const artistRoyalties = useMemo(() => {
    return (totalCost.wei * BigInt(10)) / BigInt(100);
  }, [totalCost]);

  return (
    <div className="grid gap-3">
      <div className="flex justify-between text-base-m text-base800">
        <div>Artist Royalties (10%)</div>
        <div>{`${formatWeiToEthForDisplay({
          weiValue: artistRoyalties,
          maxDecimals: 10,
          hideCloseToZero: true,
        })} ETH`}</div>
      </div>
      <div className="flex justify-between font-title text-title-m font-medium text-base900">
        <div>Total</div>
        <div className="flex flex-col justify-end">
          <div className="flex items-center gap-1">
            <NetworkIndicator chainId={chainId} size="sm" />
            <div>
              {`${formatWeiToEthForDisplay({
                weiValue: totalCost.wei,
                maxDecimals: 10,
                hideCloseToZero: true,
              })} ETH`}
            </div>
          </div>
          <p className="text-end text-base-m !font-light text-base400">{`~${formatUSD(
            totalCost.usd,
          )}`}</p>
        </div>
      </div>
    </div>
  );
};
